// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card.theme--dark[data-v-0875197f],.v-card.theme--light[data-v-0875197f]{background-color:#fff!important}.caption[data-v-0875197f]{text-transform:uppercase}.body-1[data-v-0875197f]{font-weight:500}", ""]);
// Exports
module.exports = exports;
